import TemplateView from '../../TemplateView'
import UserInitialsIcon from '../../components/UserInitialsIcon'
import {LOGGED_IN_USER_ICON_COLOR} from './constants'
import LoadingContainer from '../../util/LoadingContainer'
import CommentInput from './CommentInput'

export default class CommentInputContainer extends TemplateView {
    constructor({
        userInfo,
        onCommentTextChange = () => {},
        onShowInputChanged = () => {},
        onCommentAdded = () => {},
        refreshScrollCb = () => {},
    }) {
        super()

        this.params = {
            userInfo
        }

        this.callbacks = {
            onCommentTextChange,
            onShowInputChanged,
            onCommentAdded,
            refreshScrollCb,
        }

        this.state = {
            showCommentInput: false,
            commentText: '',
            sending: false,
        }

        this.onStatePropertyChanged('sending', sending => {
            this.loadingWrapper.setState({loading: sending})
        })

        this.onStatePropertyChanged('showCommentInput', showInput => {
            this.commentInput.setState({showInput})
        })

        this.onStatePropertyChanged('commentText', commentText => {
            this.commentInput.setState({text: commentText})
        })
    }

    templateHtml() {
        return "<div class='commentInputContainer'/>"
    }

    afterRender() {
        new UserInitialsIcon({
            firstName: this.params.userInfo.firstName,
            lastName: this.params.userInfo.lastName,
            color: LOGGED_IN_USER_ICON_COLOR
        }).init(this.getEl())

        this.commentInput = new CommentInput({
            onShowInputChanged: this.callbacks.onShowInputChanged,
            onTextChange: this.callbacks.onCommentTextChange,
            onCommentAdded: this.callbacks.onCommentAdded,
            refreshScrollCb: this.callbacks.refreshScrollCb,
        })

        this.loadingWrapper = new LoadingContainer({
            contentComponent: this.commentInput,
            containerClass: 'commentInputLoadingWrapper',
        }).init(this.getEl())
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/CommentInputContainer.js